import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// The brief hand-off state. `fallbackUrl` is the escape hatch for a blocked or
// slow automatic redirect, and MUST be passed for the redirecting step.
//
// It is deliberately NOT rendered as <a href={fallbackUrl}>. On the success
// path that URL carries the live authorization code, and an anchor would put
// the code into the DOM on the hajexbolt.com origin -- readable by the Google
// Analytics and Maps tags that index.html loads on every page, and captured
// verbatim as link_url by GA4's outbound-click tracking, which is on by
// default. A button that navigates from a closure keeps the code out of the
// markup entirely.
const RedirectingCard = ({ label, fallbackUrl }) => {
  const { t } = useTranslation("auth");
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setSlow(true), 3000);
    return () => clearTimeout(id);
  }, []);

  return (
    <div className="p-10 text-center">
      <div className="mx-auto h-10 w-10 animate-spin rounded-full border-b-2 border-brand" />
      <p className="mt-4 text-[13px] font-medium text-ui-text" aria-live="polite">
        {label || t("oauth.returning")}
      </p>
      {slow && fallbackUrl && (
        <button
          type="button"
          onClick={() => window.location.replace(fallbackUrl)}
          className="mt-3 inline-block text-[12px] font-semibold text-brand hover:underline"
        >
          {t("oauth.continueManually")}
        </button>
      )}
    </div>
  );
};

export default RedirectingCard;
